import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";
import { OrderList } from "../../../../Component/Interface/Order";
import RenderMultiRows2, {
  HeaderRow,
  Row,
} from "../../../../Component/style/orderTable_style2";
import { fontStyles } from "../../../../Component/style/common_font";
import { useState } from "react";
import MatchingApplyModal from "./MatchingApplyModal";

interface MatchingModalProps extends modalProps {
  data: OrderList;
}

interface depositData {
  date: string;
  name: string;
  price: number;
  note: string;
}

interface matchingData extends depositData {
  order_dt: string;
  order_name: string;
  delivery_price: number;
  order_price: number;
}

interface TableStyle {
  $width?: number | null;
  $height?: number | null;
}

const MatchingModal = ({ visible, handleModal, data }: MatchingModalProps) => {
  const closeModal = () => {
    handleModal();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const [depositData, setDepositData] = useState<depositData[]>([
    {
      date: "2023-10-01",
      name: "홍길동",
      price: 10000,
      note: "입금 확인",
    },
    {
      date: "2023-10-02",
      name: "김철수",
      price: 20000,
      note: "입금 확인",
    },
    {
      date: "2023-10-03",
      name: "이영희",
      price: 30000,
      note: "입금 확인",
    },
  ]);
  const [matchingData, setMatchingData] = useState<matchingData[]>([
    {
      date: "2023-10-03",
      name: "이영희1",
      price: 30000,
      note: "입금 확인",
      delivery_price: 3500,
      order_dt: "2025-10-03 00:01:02",
      order_name: "꼬라지",
      order_price: 32500,
    },
    {
      date: "2023-10-03",
      name: "이영희2",
      price: 30000,
      note: "입금 확인",
      delivery_price: 3500,
      order_dt: "2025-10-03 00:01:02",
      order_name: "꼬라지",
      order_price: 32500,
    },
    {
      date: "2023-10-03",
      name: "이영희3",
      price: 30000,
      note: "입금 확인",
      delivery_price: 3500,
      order_dt: "2025-10-03 00:01:02",
      order_name: "꼬라지",
      order_price: 32500,
    },
    {
      date: "2023-10-03",
      name: "이영희4",
      price: 30000,
      note: "입금 확인",
      delivery_price: 3500,
      order_dt: "2025-10-03 00:01:02",
      order_name: "꼬라지",
      order_price: 32500,
    },
  ]);
  const [select, setSelect] = useState<string>("매칭대기");
  const [search_startDt, setPre_Search_startDt] = useState("");
  const [search_endDt, setPre_Search_endDt] = useState("");
  const setting_search_startDt = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPre_Search_startDt(e.target.value);
    if (search_endDt === "" || search_endDt < e.target.value)
      setPre_Search_endDt(e.target.value);
  };
  const setting_search_endDT = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPre_Search_endDt(e.target.value);
    if (search_startDt === "" || search_startDt > e.target.value)
      setPre_Search_startDt(e.target.value);
  };

  // 페이징
  const [perPage, setPerPage] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [maxPaging, setMaxPaging] = useState<number>(15);
  const nextPage = () => {
    if (currentPage < maxPaging) {
      setCurrentPage(currentPage + 1);
      if (currentPage === perPage) {
        setPerPage(perPage + 10);
      }
    }
  };
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      if (currentPage + 9 === perPage) {
        setPerPage(perPage - 10);
      }
    }
  };
  const handlePage = (newPage: number) => {
    setCurrentPage(newPage);
  };

  // 모달
  const [applyVisible, setApplyVisible] = useState(false);
  const [type, setType] = useState<string>("");
  const [selectData, setSelectData] = useState<depositData>({
    date: "",
    name: "",
    price: 0,
    note: "",
  });
  const handleApplyModal = (data?: depositData, type?: string) => {
    data && setSelectData(data);
    setApplyVisible(!applyVisible);
    type && setType(type);
  };

  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>
          <RowView style={{ gap: "5px" }}>
            <Icon src={require("../../../../Image/ic_alert_red.png")} />
            입금정보 매칭하기
          </RowView>
          <Icon
            className="btn"
            src={require("../../../../Image/ic_closeX.png")}
            onClick={closeModal}
          />
        </Title>
        <ContentDiv>
          <SubTitle>주문정보</SubTitle>
          <TableHeader>
            <HeaderRow $width={4}>주문자</HeaderRow>
            <HeaderRow $width={5}>입금자</HeaderRow>
            <HeaderRow $width={5}>택배비</HeaderRow>
            <HeaderRow>주문일시</HeaderRow>
            <HeaderRow $width={2}>상품 번호</HeaderRow>
            <HeaderRow>품목명</HeaderRow>
            <HeaderRow>옵션</HeaderRow>
            <HeaderRow $width={5}>단가</HeaderRow>
            <HeaderRow $width={2}>수량</HeaderRow>
            <HeaderRow $width={5}>총 금액</HeaderRow>
            <HeaderRow $width={7}>받는 분 전화</HeaderRow>
          </TableHeader>

          <Table $height={data.order_details.length || 1}>
            <Row $width={4}>{data.order_name}</Row>
            <Row $width={5}>{data.order_nickname}</Row>
            <Row $width={5}>{data.delivery_price}</Row>

            {[
              { key: "주문일시" },
              { key: "상품번호", width: 2 },
              { key: "품목명" },
              { key: "옵션" },
              { key: "단가", width: 5 },
              { key: "수량", width: 2 },
              { key: "총 금액", width: 5 },
            ].map(({ key, width }) => (
              <Row key={key} $width={width}>
                <RenderMultiRows2
                  detailData={data.order_details}
                  searchkey={key}
                />
              </Row>
            ))}
            <Row $width={7}>{data.addr_phone}</Row>
          </Table>
          <SubTitle style={{ marginTop: 40 }}>입금정보</SubTitle>
          <RowView2 style={{ width: "100%", marginTop: "16px" }}>
            <SelectBtn
              $select={select === "매칭대기"}
              onClick={() => {
                setSelect("매칭대기");
                setCurrentPage(1);
                setPerPage(10);
              }}
            >
              매칭대기
            </SelectBtn>
            <SelectBtn
              $select={select === "매칭완료"}
              onClick={() => {
                setSelect("매칭완료");
                setCurrentPage(1);
                setPerPage(10);
              }}
            >
              매칭완료
            </SelectBtn>
          </RowView2>
          <SearchRow>
            <RowView>
              <SearchInputDiv>
                <Icon src={require("../../../../Image/ic_find_black.png")} />
                <SearchInput
                  placeholder="입금자명을 입력해주세요."
                  type="text"
                />
              </SearchInputDiv>
              <SearchBtn>검색</SearchBtn>
              <ResetBtn>
                <Icon src={require("../../../../Image/ic_reset_black.png")} />
              </ResetBtn>
            </RowView>
            <RowView2>
              <DateInput
                type={"date"}
                value={search_startDt}
                onChange={setting_search_startDt}
              />
              <div
                style={{
                  position: "relative",
                  marginBottom: "1rem",
                  marginRight: "1rem",
                }}
              >
                ~
              </div>
              <DateInput
                type={"date"}
                value={search_endDt}
                onChange={setting_search_endDT}
              />
            </RowView2>
          </SearchRow>

          {select === "매칭대기" ? (
            <>
              <TableHeader>
                <HeaderRow $width={10}>입금일시</HeaderRow>
                <HeaderRow $width={7}>입금자명</HeaderRow>
                <HeaderRow $width={7}>입금액</HeaderRow>
                <HeaderRow>불일치 사유</HeaderRow>
                <HeaderRow $width={14}></HeaderRow>
              </TableHeader>
              {depositData.map((item, index) => (
                <Table key={index}>
                  <TableRow $width={10}>{item.date}</TableRow>
                  <TableRow $width={7}>{item.name}</TableRow>
                  <TableRow $width={7}>{item.price}</TableRow>
                  <TableRow>{item.note}</TableRow>
                  <TableRow $width={14}>
                    <RowView style={{ gap: "10px" }}>
                      <DepositBtn
                        $num={0}
                        onClick={() => handleApplyModal(item, "삭제")}
                      >
                        리스트 삭제
                      </DepositBtn>
                      <DepositBtn
                        $num={1}
                        onClick={() => handleApplyModal(item, "매칭")}
                      >
                        매칭하기
                      </DepositBtn>
                    </RowView>
                  </TableRow>
                </Table>
              ))}
            </>
          ) : (
            <>
              <TableHeader>
                <HeaderRow $width={6}>주문일시</HeaderRow>
                <HeaderRow $width={4}>주문자</HeaderRow>
                <HeaderRow $width={4}>택배비</HeaderRow>
                <HeaderRow $width={7}>총 결제금액</HeaderRow>
                <HeaderRow $width={7}>입금일시</HeaderRow>
                <HeaderRow $width={7}>입금자</HeaderRow>
                <HeaderRow $width={7}>입금액</HeaderRow>
                <HeaderRow>불일치 사유</HeaderRow>
              </TableHeader>
              {matchingData.map((item, index) => (
                <Table key={index}>
                  <TableRow $width={6}>{item.order_dt}</TableRow>
                  <TableRow $width={4}>{item.order_name}</TableRow>
                  <TableRow $width={4}>{item.delivery_price}</TableRow>
                  <TableRow $width={7}>{item.order_price}</TableRow>
                  <TableRow $width={7}>{item.date}</TableRow>
                  <TableRow $width={7}>{item.name}</TableRow>
                  <TableRow $width={7}>{item.price}</TableRow>
                  <TableRow>{item.note}</TableRow>
                </Table>
              ))}
            </>
          )}
        </ContentDiv>
        <PagingDiv>
          <NextBtn onClick={prevPage}>
            <Icon
              style={{ margin: 0 }}
              className={currentPage === 1 ? "gray" : ""}
              src={require("../../../../Image/Admin/ic_paging_left.png")}
            />
          </NextBtn>
          {Array.from({ length: perPage }, (_, index) => (
            <PageBtn
              style={{
                display:
                  index + 1 > perPage - 10 && index < maxPaging
                    ? "flex"
                    : "none",
              }}
              key={index + 1}
              $select={currentPage === index + 1}
              onClick={() => handlePage(index + 1)}
            >
              {index + 1}
            </PageBtn>
          ))}
          <NextBtn onClick={nextPage}>
            <Icon
              style={{ margin: 0 }}
              className={currentPage === maxPaging ? "gray" : ""}
              src={require("../../../../Image/Admin/ic_paging_right.png")}
            />
          </NextBtn>
        </PagingDiv>
      </ModalBox>
      <MatchingApplyModal
        visible={applyVisible}
        handleModal={handleApplyModal}
        data={selectData}
        type={type}
      />
    </Container>
  );
};
export default MatchingModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 65%;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: auto;
  padding: 35px 30px;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const SubTitle = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const ContentDiv = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  text-align: center;
`;

const PagingDiv = styled(RowView)`
  position: relative;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const TableHeader = styled(RowView2)`
  margin-top: 16px;
  width: 100%;
  height: 2.5rem;
  border-top: 1px solid #8e8e8e;
  border-left: 1px solid #8e8e8e;
  ${fontStyles.Bold}
  background-color: #e5e5e5;
`;

const Table = styled(RowView2)<{ $height?: number }>`
  width: 100%;
  border-right: 1px solid #8e8e8e;
  height: ${(props) => (props.$height ? `${props.$height * 2.5}rem` : "3rem")};
`;

const SelectBtn = styled.div<{ $select?: boolean }>`
  padding: 16px 24px;
  background-color: ${(props) => (props.$select ? "#2d2d2d" : "#f0f0f0")};
  color: ${(props) => (props.$select ? "white" : "#8E8E8E")};
  border-radius: 8px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
  margin-right: 8px;
  font-size: 16px;
`;

const SearchRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 8px;
`;

const SearchInputDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  width: 260px;
  padding: 2px 10px;
  gap: 5px;
`;

const SearchInput = styled.input`
  width: 90%;
  height: 24px;
  border: none;
  outline: none;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
`;

const SearchBtn = styled.div`
  cursor: pointer;
  background-color: black;
  height: 40px;
  width: 50px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: var(--font-Pretendard-Medium);
  color: white;
  margin-left: 8px;
`;

const ResetBtn = styled.div`
  cursor: pointer;
  background-color: white;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  display: flex;
  border: 1px solid #f0f0f0;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
`;

const DateInput = styled.input`
  position: relative;
  box-sizing: border-box;
  flex: 1;
  height: 44px;
  padding: 1rem;
  font-size: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  &:hover,
  &:focus {
    border: 1px solid #454545;
  }
`;

const TableRow = styled(CenterView)<TableStyle>`
  height: 3rem;
  flex: 1;
  max-width: ${(props) => (props.$width ? `${props.$width}rem` : "auto")};
  word-break: keep-all;
  text-align: center;
  border-bottom: 1px solid #8e8e8e;
  border-left: 1px solid #8e8e8e;
  overflow: hidden;
  &.flex3 {
    flex: 2;
  }
  &.last {
    border-right: 1px solid #8e8e8e;
  }
`;

const DepositBtn = styled.div<{ $num: number }>`
  padding: 10px 16px;
  background-color: ${(props) => (props.$num === 0 ? "#f0f0f0" : "#7955f0")};
  color: ${(props) => (props.$num === 1 ? "white" : "#8e8e8e")};
  border-radius: 8px;
  font-size: 14px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const PageBtn = styled.div<{ $select?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  background-color: ${(props) => (props.$select ? "#f0f0f0" : "white")};
  color: black;
  border: ${(props) =>
    props.$select ? "1px solid #f0f0f0" : "1px solid #d8d8d8"};
  cursor: pointer;
`;

const NextBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  background-color: white;
  border: 1px solid #d8d8d8;
  cursor: pointer;
`;
